import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, CircularProgress, Typography } from '@mui/joy';
import { useClerk } from '@clerk/clerk-react';

import { SessionService } from '../services/SessionService';
import organizationStore from '../stores/OrganizationStore';
import sessionStore from '../stores/SessionStore';

const Logout = () => {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  useEffect(() => {
    const run = async (): Promise<void> => {
      // Clear local state first to prevent ProtectedRoute from rendering
      // the previous page while async logout calls are in flight.
      sessionStore.setIsAuthenticated(false);
      sessionStore.clearSession();
      organizationStore.clearSelectedOrg();

      try {
        await SessionService.fetchCSRFToken();
      } catch {
        // ignore
      }

      try {
        await SessionService.logout();
      } catch {
        // ignore
      }

      try {
        await signOut();
      } catch {
        // ignore
      }

      navigate('/login', { replace: true });
    };

    run().catch(() => undefined);
  }, [navigate, signOut]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
      <Typography level='body-md' sx={{ mt: 2 }}>Signing out…</Typography>
    </Box>
  );
};

export default Logout;
